export default __webpack_public_path__ + "static/media/1.297502e7.webp";